import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=006ea6ba&scoped=true&"
import script from "./SmsList.vue?vue&type=script&lang=ts&"
export * from "./SmsList.vue?vue&type=script&lang=ts&"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=006ea6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ea6ba",
  null
  
)

export default component.exports